(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/kambi-widget-utils/assets/javascripts/definitions/tooltip-widget-definition.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/kambi-widget-utils/assets/javascripts/definitions/tooltip-widget-definition.js');
"use strict";


const {
  KambiWidgetDefinition
} = svs.oddset_kambi.components.kambiWidgetUtils.definitions;
const {
  WIDGET_ID,
  WIDGET_TAG
} = svs.oddset_kambi.components.kambiWidgetUtils.constants;
const {
  tooltipTarget
} = svs.oddset_kambi.data;
class TooltipWidgetDefinition extends KambiWidgetDefinition {
  constructor() {
    super(WIDGET_ID.tooltipWidget, WIDGET_TAG.tooltipWidget, tooltipTarget);
  }
}
setGlobal('svs.oddset_kambi.components.kambiWidgetUtils.definitions.TooltipWidgetDefinition', TooltipWidgetDefinition);

 })(window);